module.exports = __webpack_public_path__ + "img/Maradona-1.78803cf3.webp";